module.exports = __webpack_public_path__ + "static/media/lumbering3.cda78869.jpg";